import * as React from 'react';
import './style.scss';
import Text from '../Text';
import Button from '../Button';
import WideCard from '../WideCard';

const TellUsMore: React.FC = () => {
  return (
    <WideCard lightCard direction="up">
      <Text
        type="p"
        color="light"
        weight="bold"
        className={'title h4'}
        align="center"
      >
        Let’s Build Something Great Together?
      </Text>
      <Button
        color="light"
        href="/contact-us/"
        size="medium"
        className={'button'}
      >
        <Text color="primary" weight="bold" type="label" className="h6">
          Drop us a message
        </Text>
      </Button>
    </WideCard>
  );
};

export default TellUsMore;
